<div class="pedido-item-drp-view">
    <table class="table table-striped table-hover table-bordered" [id]="idTable" *ngIf="tabelaVisivel">
        <thead>
            <tr class="row-1">
                <th class="col-codigo-item" rowspan="2">Cód.</th>
                <th class="col-item" rowspan="2">Item</th>
                <th class="col-qv-grupo-rentabilidade text-left" rowspan="2" title="Qualidade de Valor" *ngIf="config.canShowQV">QV</th>
                <th class="col-valor-unitario text-right" rowspan="2">Unitário</th>
                <th class="col-quantidade text-right" rowspan="2">Quantidade</th>
                <th class="col-perc-desc-1 text-right" rowspan="2" title="Desconto 1">Desc. 1</th>
                <th class="col-perc-desc-2 text-right" rowspan="2" title="Desconto 2" *ngIf="configPedido?.exibirPercDesconto2">Desc. 2</th>
                <th class="col-perc-desc-avista text-right" rowspan="2" title="Desconto A Vista">Desc. A Vista</th>
                <th class="col-valor-liquido text-right" rowspan="2">Unitário Bruto</th>
                <ng-container *ngFor="let grupo of grupos">
                    <th *ngIf="grupo.campoPerc" class="text-center" colspan="2"
                        [sgtTooltip]="grupo.legenda || grupo.titulo">{{grupo.tituloItem || grupo.titulo}}</th>
                    <th *ngIf="!grupo.campoPerc" class="col-drp-valor-{{grupo.slug}} text-right" rowspan="2"
                        [sgtTooltip]="grupo.legenda || grupo.titulo">{{grupo.tituloItem || grupo.titulo}}</th>
                </ng-container>
            </tr>
            <tr class="row-2">
                <ng-container *ngFor="let grupo of grupos">
                    <ng-container *ngIf="grupo.campoPerc">
                        <th class="col-drp-valor-{{grupo.slug}} text-right">R$</th>
                        <th class="col-drp-perc-{{grupo.slug}} text-right">%</th>
                    </ng-container>
                </ng-container>
            </tr>
        </thead>
        <tbody *ngIf="!pedidoItens || pedidoItens.length == 0">
            <tr>
                <td class="text-center" [attr.colspan]="totalColunas">
                    <i class='fas fa-info' aria-hidden='true'></i> Nenhum item adicionando ao pedido
                </td>
            </tr>
        </tbody>
    </table>
</div>

<!-- Container para criar dinamicamente de badges para a datatable -->
<ng-template #badgesContainer></ng-template>
